import React from "react";
import CV from "../../assets/cv.pdf";
import "animate.css/animate.min.css";
import { AnimationOnScroll } from "react-animation-on-scroll";

function CTA() {
  return (
    <div className="cta">
      <AnimationOnScroll animateIn="animate__fadeInLeftBig">
        <a href={CV} download className="btn">
          Dowmload CV
        </a>
      </AnimationOnScroll>
      <AnimationOnScroll animateIn="animate__fadeInRightBig">
        <a href="#contact" className="btn btn-primary">
          Let's Talk
        </a>
      </AnimationOnScroll>
    </div>
  );
}

export default CTA;
